import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          I miei <strong className="purple">Progetti </strong>
        </h1>
        <h4 style={{ color: "white" }}>
          Qui troverete i miei progetti attivi e del passato.
        </h4>
        <br />
        <h3 className="project-heading">
          Progetti <strong className="purple">Attivi </strong>
        </h3>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath="https://i.imgur.com/MQuiNzx.jpeg"
              isBlog={false}
              title="Master's Shoots"
              description="Master's Shoots è nato il 23 giugno 2023 ed è un canale molto noto sia su Tecno/Zero che su Atlantis. 
              Dispone di un team specializzato che offre servizi come: fotografie, creazione di grafiche, separatori Telegram, personalizzazione di skin, emoji Telegram Premium, editing video, creazione di texture e tanto altro. 
              L'obiettivo principale è offrire la migliore qualità al miglior prezzo."
              ghLink="https://t.me/MasterShoots"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath="https://i.imgur.com/fOWNxqX.jpeg"
              isBlog={false}
              title="AtlantisPolitics"
              description="Politics è la testata giornalistica ufficiale di Atlantis, sono stato nominato Direttore il 19 giugno 2025. 
                            Sebbene gli articoli siano incentrati principalmente sugli eventi politici di Liberty Bay, l'offerta spazia ben oltre: vengono realizzate interviste a politici noti ed emergenti, quiz sul mondo politico, sondaggi sulle intenzioni di voto e dibattiti tra capi partito e candidati, svolti su un palco e trasmessi in diretta TV."
              ghLink="https://t.me/PoliticaAtlantisRp"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath="https://i.imgur.com/RPiavT5.jpeg"
              isBlog={false}
              title="TecnoTruckers"
              description="TecnoTruckers è una community dedicata a Euro Truck Simulator 2 e American Truck Simulator, fondata da me, _Steef e SemplicementeAle. Il gruppo riunisce giocatori provenienti da Tecno/Zero e, più recentemente, di Atlantis.
               Attualmente contiamo 89 membri, in costante crescita e organizziamo regolarmente convogli di gruppo. Disponiamo di un server Discord per comunicare e gestire la nostra azienda virtuale tramite la piattaforma TrucksBook, che traccia tutte le consegne.
              Siamo orgogliosi dei nostri risultati: l'azienda ha raggiunto la Top 12 in Italia nella categoria Gara e la Top 67 nella categoria Km Reali."
              ghLink="https://t.me/+XDg391Q9SU01NTY8" 
              demoLink="https://trucksbook.eu/company/194389#google_vignette"         
            />
          </Col>
          
        <h3 className="project-heading">
          Progetti <strong className="purple">Storici </strong>
        </h3>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath="https://i.imgur.com/ioov97B.jpeg"
              isBlog={false}
              title="TecnoBids"
              description="TecnoBids è stata un'azienda privata di aste attiva su Tecno/Zero, fondata da me e Deastt_ nel novembre 2022. Nonostante fosse un'azienda emergente, riuscì in breve tempo a competere con le aziende storiche del server.
              Il nostro punto di forza erano le aste esclusive di oggetti rari e vecchi dove c'erano pochi in circolazione, che ci garantirono originalità e fama. L'offerta era però molto varia: vendevamo box di alimentari a prezzi competitivi, regalavamo oggetti al primo che ci trovava in città, organizzavamo lotterie dove si potevano vincere soldi, oggetti, infine gestivamo vendite lampo ad aggiudicazione immediata. Successivamente, espandemmo l'attività alla Bancarella 9 in piazza, vendendo cibo, bibite, mistery box e gratta e Vinci. 
              L'azienda ha cessato l'attività il 24 luglio 2023 per mancanza di tempo."
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath="https://i.imgur.com/78zMAdD.jpeg"
              isBlog={false}
              title="TecnoMagazine"
              description="TecnoMagazine è stata una testata giornalistica indipendente di Tecno/Zero, fondata il 1° giugno 2023 da B0mba_. La gestione è stata successivamente trasferita a giktNicoo, _laavii e al sottoscritto il 6 giugno 2025.
              La redazione copriva a 360 gradi la vita della città: dagli eventi aziendali alla cronaca nera, passando per i cambi ai vertici societari e le operazioni delle forze dell'ordine. 
              Grande spazio era dedicato alla politica, con news e sondaggi sulle intenzioni di voto.
              I nostri format includevano interviste a direttori, figure storiche, politici e volti noti, oltre a rubriche di curiosità e intrattenimento. Tra questi spiccavano i quiz di cultura generale e il gioco a indizi Guess the, in cui i lettori dovevano indovinare un personaggio tramite indizi a tempo: la rapidità di risposta determinava il valore del premio in denaro. A causa di difficoltà gestionali, la testata è stata venduta il 7 settembre 2025."
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath="https://i.imgur.com/LokeStq.jpeg"
              isBlog={false}
              title="StreetFood"
              description="StreetFood è stata un'azienda privata attiva su Tecno/Zero, fondata da me e GinoPino81 il 6 agosto 2023. La bancarella, situata in una posizione strategica presso i Lavori Base, riscosse un notevole successo di vendite.
              L'offerta spaziava dalla vendita al dettaglio di cibo, bibite e Gratta e Vinci, fino alla creazione di speciali box di cibo e bevande e l'organizzazione di aste di oggetti. Il progetto ha avuto però breve durata: il 4 ottobre 2023, alla scadenza del contratto d'affitto, l'attività è cessata. A causa della lunga lista d'attesa per riottenere la postazione, si è deciso di non riprendere l'attività."
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
